export default __webpack_public_path__ + "static/media/db_phone_icon.20e0f991.svg";